// Storage types
export const nextcloud = 'urn:openproject-org:api:v3:storages:Nextcloud';
export const oneDrive = 'urn:openproject-org:api:v3:storages:OneDrive';

// Storage authorization state
export const storageConnected = 'urn:openproject-org:api:v3:storages:authorization:Connected';
export const storageFailedAuthorization = 'urn:openproject-org:api:v3:storages:authorization:FailedAuthorization';
export const storageAuthorizationError = 'urn:openproject-org:api:v3:storages:authorization:Error';

// File link view permission flags
export const fileLinkViewAllowed = 'urn:openproject-org:api:v3:file-links:permission:View';
export const fileLinkViewNotAllowed = 'urn:openproject-org:api:v3:file-links:permission:NotAllowed';
export const fileLinkViewError = 'urn:openproject-org:api:v3:file-links:permission:Error';
